export default __webpack_public_path__ + "static/media/check.6294639e.svg";